import React from 'react';
import Imgix from 'react-imgix';
import {getImgCDNDomain, getJSONFromHtml} from "../../../domain/common";
import {isMobile} from "../../../domain/common";

const ArtistsQuotes = (props:any) => {
    const data = getJSONFromHtml(document.getElementById(props.props.source));
    const imgDomain = getImgCDNDomain();
    const checkIsMobile = isMobile();

    const decodeHTML = (html:any) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };
    return (
        <div className="waves-box-lg mx-auto px-5 md:px-12 md:pt-8 flex">
            <ul className="grid md:gap-12 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 relative prod-mobile-2col">
                {
                    data.map((item: any, index: number) => {
                        return ( <li key={item.itemGUID + ' ' + index}>
                            <div className="flex flex-col">
                                <div>
                                    <Imgix
                                        src={`${imgDomain}${item.artistImage}`}
                                        className="max-w-full"
                                        htmlAttributes={{
                                            alt: decodeHTML(item.artistName),
                                            title: decodeHTML(item.artistName),
                                            loading: 'lazy',
                                        }}
                                    />
                                </div>
                                <div className="waves-box-md mx-auto py-6 text-start">
                                    <p className="waves-p md:h-28 md:pb-0 pb-4">{`“${item.quote}”`}</p>
                                    <p className="waves-h3 pb-0">{decodeHTML(item.artistName)}</p>
                                    <p className="waves-p pb-2">{decodeHTML(item.artistTitle)}</p>
                                    <p className="waves-p font-bold">{decodeHTML(item.credits)}</p>
                                </div>
                            </div>
                        </li>)
                    })
                }
            </ul>
        </div>
    )
}

export default ArtistsQuotes;